import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const FeedSearch = lazy(() => import('./pages/FeedSearch'));
const FeedDetail = lazy(() => import('./pages/FeedDetail'));

export const feedsRoutes: RouteObject = {
  path: 'feeds',
  handle: { breadcrumb: 'Content' },
  children: [
    { index: true, element: <FeedSearch />, handle: { breadcrumb: 'Search' } },
    { path: ':feedId', element: <FeedDetail />, handle: { breadcrumb: 'Detail' } },
  ],
};
